import React from 'react'
import SalesOverview from '../SalesOverview'
import type { BasicWidgetProps } from '../../../types'

const SalesThisWeek: React.FC<BasicWidgetProps> = ({ config, widgetId, handleConfig, readonly }: BasicWidgetProps) => {
    return (
        <div data-test="ThisWeek">
            <SalesOverview config={config} widgetId={widgetId} handleConfig={handleConfig} readonly={readonly} />
        </div>
    )
}

export default SalesThisWeek
